<template>
  <div class="recursive-menu-container" :class="`level-${level}`" v-show="isVisible || level > 1">
    <div class="menu-columns">
      <!-- 检查是否有 Block_Only 项目 -->
      <div v-if="blockOnly && blockOnly.length" class="block-only-container">
        <swiper class="swiper-x-container" :options="swiperFeatureOption" v-if="blockOnly.length > 6">
          <swiper-slide class="swiper-block-only-item" v-for="(item, index) in blockOnly" :key="index">
            <a v-if="item.url" :href="item.url" target="_blank" @click="$emit('menu-click')" class="block-only-link"
              :title="item.name">
              <img v-if="item.cover" :src="item.cover" :alt="item.name" class="block-only-image" />
              <span class="block-only-name multiline-2">{{ item.name }}</span>
            </a>
            <router-link v-else :to="getRoutePath(item, parentCode)" :title="item.name" @click.native="$emit('menu-click')"
              class="block-only-link">
              <img v-if="item.cover" :src="item.cover" :alt="item.name" class="block-only-image" />
              <span class="block-only-name multiline-2">{{ item.name }}</span>
            </router-link>
          </swiper-slide>
          <div class="arrow arrow-left" slot="button-prev">
            <i class="iconfont-ot-website icon-left-arrow">&#xe68f;</i>
          </div>
          <div class="arrow arrow-right" slot="button-next"> <i
              class="iconfont-ot-website icon-right-arrow">&#xe68f;</i>
          </div>
        </swiper>
        <div v-else v-for="(item, index) in blockOnly" :key="`block-${index}`" class="block-only-item">
          <a v-if="item.url" :href="item.url" target="_blank" @click="$emit('menu-click')" class="block-only-link"
            :title="item.name">
            <img v-if="item.cover" :src="item.cover" :alt="item.name" class="block-only-image" />
            <span class="block-only-name multiline-2">{{ item.name }}</span>
          </a>
          <router-link v-else :to="getRoutePath(item, parentCode)" :title="item.name" @click.native="$emit('menu-click')"
            class="block-only-link">
            <img v-if="item.cover" :src="item.cover" :alt="item.name" class="block-only-image" />
            <span class="block-only-name multiline-2">{{ item.name }}</span>
          </router-link>
        </div>
      </div>

      <!-- 正常分列显示 -->
      <template v-else>
        <!-- 第一列 (16%) -->
        <div class="column first-column" v-if="firstColumnItems.length > 0">
          <div v-for="(child, index) in firstColumnItems" :key="`first-${index}`" class="menu-item"
            :class="`level-${level + 1}`">
            <a class="multiline-1" v-if="child.url && child.show" :href="child.url" target="_blank"
              @click="$emit('menu-click')" :title="child.name">
              {{ child.name }}
            </a>
            <router-link class="multiline-1" v-else-if="child.show" :title="child.name" :to="getRoutePath(child, item.code)"
              @click.native="$emit('menu-click')">
              {{ child.name }}
            </router-link>

            <!-- 直接渲染子菜单项，不需要条件显示 -->
            <div v-if="child.children && child.children.length" class="children-container">
              <div v-for="(subChild, subIndex) in child.children" :key="`sub-${index}-${subIndex}`"
                class="sub-menu-item" :class="`level-${level + 2}`">
                <a class="multiline-1" v-if="subChild.url && subChild.show" :href="subChild.url" target="_blank"
                  @click="$emit('menu-click')" :title="subChild.name">
                  {{ subChild.name }}
                </a>
                <router-link class="multiline-1" v-else-if="subChild.show" :title="subChild.name"
                  :to="getRoutePath(subChild, item.code, child.code)" @click.native="$emit('menu-click')">
                  {{ subChild.name }}
                </router-link>

                <!-- 继续渲染更深层级 -->
                <div v-if="subChild.children && subChild.children.length" class="children-container">
                  <template v-for="(subSubChild, subSubIndex) in subChild.children">
                    <div v-if="subSubChild.show" :key="`sub-sub-${index}-${subIndex}-${subSubIndex}`"
                      class="sub-sub-menu-item" :class="`level-${level + 3}`">
                      <a class="multiline-1" v-if="subSubChild.url" :href="subSubChild.url" target="_blank"
                        @click="$emit('menu-click')" :title="subSubChild.name">
                        {{ subSubChild.name }}
                      </a>
                      <router-link class="multiline-1" v-else :title="subSubChild.name" :to="getRoutePath(subSubChild, item.code, child.code, subChild.code)"
                        @click.native="$emit('menu-click')">
                        {{ subSubChild.name }}
                      </router-link>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 第二列 (16%) -->
        <div class="column second-column" v-if="secondColumnItems.length > 0">
          <div v-for="(child, index) in secondColumnItems" :key="`second-${index}`" class="menu-item"
            :class="`level-${level + 1}`">
            <a class="multiline-1" v-if="child.url && child.show" :href="child.url" target="_blank"
              @click="$emit('menu-click')" :title="child.name">
              {{ child.name }}
            </a>
            <router-link class="multiline-1" v-else-if="child.show" :title="child.name" :to="getRoutePath(child, item.code)"
              @click.native="$emit('menu-click')">
              {{ child.name }}
            </router-link>

            <!-- 直接渲染子菜单项，不需要条件显示 -->
            <div v-if="child.children && child.children.length" class="children-container">
              <div v-for="(subChild, subIndex) in child.children" :key="`sub-${index}-${subIndex}`"
                class="sub-menu-item" :class="`level-${level + 2}`">
                <a class="multiline-1" v-if="subChild.url && subChild.show" :href="subChild.url" target="_blank"
                  @click="$emit('menu-click')" :title="subChild.name">
                  {{ subChild.name }}
                </a>
                <router-link class="multiline-1" v-else-if="subChild.show" :title="subChild.name"
                  :to="getRoutePath(subChild, item.code, child.code)" @click.native="$emit('menu-click')">
                  {{ subChild.name }}
                </router-link>

                <!-- 继续渲染更深层级 -->
                <div v-if="subChild.children && subChild.children.length" class="children-container">
                  <template v-for="(subSubChild, subSubIndex) in subChild.children">
                    <div v-if="subSubChild.show" :key="`sub-sub-${index}-${subIndex}-${subSubIndex}`"
                      class="sub-sub-menu-item" :class="`level-${level + 3}`">
                      <a class="multiline-1" v-if="subSubChild.url" :href="subSubChild.url" target="_blank"
                        @click="$emit('menu-click')" :title="subSubChild.name">
                        {{ subSubChild.name }}
                      </a>
                      <router-link class="multiline-1" v-else :title="subSubChild.name" :to="getRoutePath(subSubChild, item.code, child.code, subChild.code)"
                        @click.native="$emit('menu-click')">
                        {{ subSubChild.name }}
                      </router-link>
                    </div>
                  </template>

                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 第三列 (16%) -->
        <div class="column third-column" v-if="thirdColumnItems.length > 0">
          <div v-for="(child, index) in thirdColumnItems" :key="`third-${index}`" class="menu-item"
            :class="`level-${level + 1}`">
            <a class="multiline-1" v-if="child.url && child.show" :href="child.url" target="_blank"
              @click="$emit('menu-click')" :title="child.name">
              {{ child.name }}
            </a>
            <router-link class="multiline-1" v-else-if="child.show" :title="child.name" :to="getRoutePath(child, item.code)"
              @click.native="$emit('menu-click')">
              {{ child.name }}
            </router-link>

            <!-- 直接渲染子菜单项，不需要条件显示 -->
            <div v-if="child.children && child.children.length" class="children-container">
              <div v-for="(subChild, subIndex) in child.children" :key="`sub-${index}-${subIndex}`"
                class="sub-menu-item" :class="`level-${level + 2}`">
                <a class="multiline-1" v-if="subChild.url && subChild.show" :href="subChild.url" target="_blank"
                  @click="$emit('menu-click')" :title="subChild.name">
                  {{ subChild.name }}
                </a>
                <router-link class="multiline-1" v-else-if="subChild.show" :title="subChild.name"
                  :to="getRoutePath(subChild, item.code, child.code)" @click.native="$emit('menu-click')">
                  {{ subChild.name }}
                </router-link>

                <!-- 继续渲染更深层级 -->
                <div v-if="subChild.children && subChild.children.length" class="children-container">
                  <template v-for="(subSubChild, subSubIndex) in subChild.children">
                    <div v-if="subSubChild.show" :key="`sub-sub-${index}-${subIndex}-${subSubIndex}`"
                      class="sub-sub-menu-item" :class="`level-${level + 3}`">
                      <a class="multiline-1" v-if="subSubChild.url" :href="subSubChild.url" target="_blank"
                        @click="$emit('menu-click')" :title="subSubChild.name">
                        {{ subSubChild.name }}
                      </a>
                      <router-link class="multiline-1" v-else :title="subSubChild.name" :to="getRoutePath(subSubChild, item.code, child.code, subChild.code)"
                        @click.native="$emit('menu-click')">
                        {{ subSubChild.name }}
                      </router-link>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 第四列 (50%) -->
        <div class="column fourth-column" v-if="hasFourthColumnContent">
          <!-- LP_Page_null 内容在上方 -->
          <!-- LP_Page_null 内容在上方 -->
          <div class="lp-page-null-section" v-if="hasLP_Page_null">
            <div :class="`lp-page-null-name level-${level + 1}`">{{ item.LP_Page_null.name }}</div>

            <div class="lp-page-null-list">
              <swiper class="swiper-x-container" :options="swiperBrandOption"
                v-if="filteredLPPageNullChildren && filteredLPPageNullChildren.length > 4">
                <swiper-slide class="swiper-block-only-item" v-for="(lpItem, index) in filteredLPPageNullChildren"
                  :key="index">
                  <a v-if="lpItem.url" :href="lpItem.url" target="_blank" @click="$emit('menu-click')"
                    :title="lpItem.name">
                    <img v-if="lpItem.cover" :src="lpItem.cover" :alt="lpItem.name" />
                  </a>
                  <router-link v-else :to="getRoutePath(lpItem, item.code, item.LP_Page_null && item.LP_Page_null.code)" :title="lpItem.name"
                    @click.native="$emit('menu-click')">
                    <img v-if="lpItem.cover" :src="lpItem.cover" :alt="lpItem.name" />
                  </router-link>
                </swiper-slide>
                <div class="arrow arrow-left" slot="button-prev">
                  <i class="iconfont-ot-website icon-left-arrow">&#xe68f;</i>
                </div>
                <div class="arrow arrow-right" slot="button-next"> <i
                    class="iconfont-ot-website icon-right-arrow">&#xe68f;</i>
                </div>
              </swiper>
              <div v-else v-for="(lpItem, index) in filteredLPPageNullChildren" :key="`lp-null-${index}`"
                class="lp-item" :class="`level-${level + 1} lp-null-count-${filteredLPPageNullChildren.length}`">
                <a v-if="lpItem.url" :href="lpItem.url" target="_blank" @click="$emit('menu-click')"
                  :title="lpItem.name">
                  <img v-if="lpItem.cover" :src="lpItem.cover" :alt="lpItem.name" />
                </a>
                <router-link v-else :to="getRoutePath(lpItem, item.code, item.LP_Page_null && item.LP_Page_null.code)" :title="lpItem.name" @click.native="$emit('menu-click')">
                  <img v-if="lpItem.cover" :src="lpItem.cover" :alt="lpItem.name" />
                </router-link>
              </div>
            </div>
          </div>

          <!-- LP_Page_name 内容在下方 -->
          <div class="lp-page-name-section" v-if="hasLP_Page_name">
            <div :class="`lp-page-name-name level-${level + 1}`">{{ item.LP_Page_name.name }}</div>
            <div class="lp-page-name-list">
              <div v-for="(lpItem, index) in filteredLPPageNameChildren" :key="`lp-null-${index}`" class="lp-item"
                :class="`level-${level + 1}`">
                <a v-if="lpItem.url" :href="lpItem.url" target="_blank" @click="$emit('menu-click')"
                  :title="lpItem.name">
                  <img v-if="lpItem.cover" :src="lpItem.cover" :alt="lpItem.name" />
                  <span class="name multiline-2">{{ lpItem.name }}</span>
                </a>
                <router-link v-else :to="getRoutePath(lpItem, item.code, item.LP_Page_name && item.LP_Page_name.code)" :title="lpItem.name" @click.native="$emit('menu-click')">
                  <img v-if="lpItem.cover" :src="lpItem.cover" :alt="lpItem.name" />
                  <span class="name multiline-2">{{ lpItem.name }}</span>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: 'RecursiveMenu',
  components: { swiper, swiperSlide },
  props: {
    item: {
      type: Object,
      required: true
    },
    menuData: {
      type: Array,
      default: () => []
    },
    level: {
      type: Number,
      default: 1
    },
    path: {
      type: Array,
      default: () => []
    },
    showBackButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isVisible: false,
      swiperFeatureOption: {
        slidesPerView: 6,
        loop: true,
        spaceBetween: 30,
        navigation: {
          nextEl: '.arrow-right',
          prevEl: '.arrow-left'
        }
      },
      swiperBrandOption: {
        slidesPerView: 4,
        loop: true,
        spaceBetween: 10,
        navigation: {
          nextEl: '.arrow-right',
          prevEl: '.arrow-left'
        }
      },
    }
  },
  computed: {

    // 只显示一个块
    blockOnly() {
      if (!this.menuData || this.menuData?.length === 0) {
        return []
      } else if (this.item.display_block === 'Block_Only') {
        return this.menuData.filter(item => item.show)
      }
      return []
    },
    filteredLPPageNullChildren() {
      if (this.item.LP_Page_null && this.item.LP_Page_null.children) {
        return this.item.LP_Page_null.children.filter(child => child.show);
      }
      return [];
    },
    filteredLPPageNameChildren() {
      if (this.item.LP_Page_name && this.item.LP_Page_name.children) {
        return this.item.LP_Page_name.children.filter(child => child.show);
      }
      return [];
    },
    // 前三个子项分别显示在前三列
    firstColumnItems() {
      if (!this.menuData || this.menuData?.length === 0) {
        return []
      } else if (this.item.display_block === 'Product_and_Block') {
        return this.menuData.slice(0, 1)
      }
      return [];
    },
    secondColumnItems() {
      if (!this.menuData || this.menuData?.length < 2) {
        return []
      } else if (this.item.display_block === 'Product_and_Block') {
        return this.menuData.slice(1, 2)
      }
      return [];
    },
    thirdColumnItems() {
      if (!this.menuData || this.menuData?.length < 3) {
        return []
      } else if (this.item.display_block === 'Product_and_Block') {
        return this.menuData.slice(2);
      }
      return [];
    },
    // 检查第四列是否有内容
    hasFourthColumnContent() {
      return (this.item.LP_Page_null && this.item.LP_Page_null.children.length > 0) ||
        (this.item.LP_Page_name && this.item.LP_Page_name.children.length > 0);
    },
    hasLP_Page_null() {
      return this.item.LP_Page_null && this.item.LP_Page_null?.children?.length > 0
    },
    hasLP_Page_name() {
      return this.item.LP_Page_name && this.item.LP_Page_name?.children?.length > 0
    },
    // 上级 code（blockOnly v-for 变量 item 遮蔽了 prop item, 用 computed 取值）
    parentCode() {
      return this.item?.code;
    }
  },
  methods: {
    // 拼接上级 code 构建层级路径，如 3/56/666
    getRoutePath(item, ...parentCodes) {
      const codes = [...parentCodes.filter(Boolean)];
      if (item.code) codes.push(item.code);
      if (codes.length === 0) return '/';
      return `/store/${codes.join('/')}`;
    }
  },
  mounted() {
    // 只有第一级菜单才需要监听hover事件
    if (this.level === 1) {
      const parentElement = this.$el.parentElement;
      if (parentElement) {
        parentElement.addEventListener('mouseenter', () => {
          this.isVisible = true;
        });
        parentElement.addEventListener('mouseleave', () => {
          this.isVisible = false;
        });
      }
    }
  },
  beforeDestroy() {
    // 清理事件监听器
    if (this.level === 1) {
      const parentElement = this.$el.parentElement;
      if (parentElement) {
        parentElement.removeEventListener('mouseenter', () => {
          this.isVisible = true;
        });
        parentElement.removeEventListener('mouseleave', () => {
          this.isVisible = false;
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.recursive-menu-container {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #fff;
  // box-shadow: 0 7px 22px 0 rgba(0, 0, 0, 0.2);
  z-index: 999;
  padding: 10px 0 60px;

  .block-only-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 30px;

    a {
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      width: 100%;
    }

    .swiper-x-container {
      // position: relative;

      .swiper-block-only-item {
        box-sizing: border-box;
        // padding: 15px;
        padding: 5px 0;

        .block-only-link {
          display: block;
          width: 100%;

          .block-only-image {
            width: 100%;
            height: auto;
            display: block;
            margin-bottom: 20px;
          }

          .block-only-name {
            color: var(---, #212322);

            /* 英文标题/H5-14-M */
            font-family: "MatterSQ";
            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            line-height: 20px;
            /* 142.857% */
            text-transform: capitalize;

            &:hover {
              text-decoration: underline;
            }
          }
        }

      }

      .arrow {
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 40%;
        transform: translate(-50%, -50%);
        color: #212322;
        z-index: 99;
        border-radius: 50%;
        /* 修改为50%透明度 */
        box-sizing: border-box;
        border: 1px solid #212322;
        background: rgba(255, 255, 255, 0.5);

        &:hover {
          background: #212322;

          .iconfont-ot-website {
            color: #fff;
          }
        }

        &.arrow-left {
          left: 36px;
        }

        &.arrow-right {
          right: 0px;
        }

        .iconfont-ot-website {
          font-size: 20px;
          // width: 20px;
          // height: 20px;


          color: #212322;


          &.icon-left-arrow {
            left: 25px;
            transform: rotate(180deg);



            &:hover {
              color: #fff;
            }
          }

          &.icon-right-arrow {
            right: 25px;

            &:hover {
              color: #fff;
            }
          }
        }
      }


    }



    .block-only-item {
      flex: 0 0 calc((100% - 150px) / 6); // 6个元素，5个间隙
      width: calc((100% - 150px) / 6);
      box-sizing: border-box;
      // padding: 15px;

      .block-only-link {
        display: block;
        width: 100%;

        .block-only-image {
          width: 100%;
          height: auto;
          display: block;
          margin-bottom: 10px;
        }

        .block-only-name {
          color: var(---, #212322);

          /* 英文标题/H5-14-M */
          font-family: "MatterSQ";
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: 20px;
          /* 142.857% */
          text-transform: capitalize;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }

  .menu-columns {
    display: flex;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    text-align: left;
    box-sizing: border-box;

    .column {
      padding: 0 15px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      // gap: 18px;
      // border-right: 1px solid #eee;

      &.first-column {
        padding: 0 15px 0 0;
      }

      &:last-child {
        border-right: none;
      }

      > :first-child {
        margin-top: 0 !important;
      }


      .menu-item,
      .lp-item,
      .sub-menu-item,
      .sub-sub-menu-item {
        // padding-bottom: 8px;
        position: relative;
        text-align: left;
        width: 100%;

        // &:not(:has(*)):not(:has(text())) {
        //   display: none;
        // }

        // 或者简单地使用 :empty 伪类（适用于完全空的元素）
        // 排除自闭合标签和媒体元素，避免意外隐藏
        :empty:not(img, input, br, hr, link, meta, source, track, wbr, area, base, col, embed, param, video, audio, canvas, iframe, svg, textarea) {
          display: none;
        }
        // :empty


        &.level-2 {
          display: flex;
          flex-direction: column;
          // gap: 10px;
          margin-bottom: 10px;
          // margin-top: 10px;



          :last-child {
            margin-bottom: 0;
          }
        }

        &.level-3 {
          a {
            font-size: 15px;
          }

          // margin-bottom: 10px;
          margin-top: 10px;

          :last-child {
            margin-bottom: 0;
          }
        }

        a,
        router-link {
          color: #000;
          text-decoration: none;
          // display: block;
          font-size: 14px;
          font-family: "MatterSQ";


          &:hover {
            text-decoration: underline;
          }
        }

        &.level-3 {
          a {
            font-size: 15px;
          }
        }

        &.level-4 {
          a {
            font-size: 13px;
          }
        }
      }

      .sub-sub-menu-item {
        margin-bottom: 10px;

        :last-child {
          margin-bottom: 0;
        }
      }

      // .level-2 {
      //   a {
      //     font-size: 16px;
      //   }
      // }


      .menu-item {
        padding: 0;
      }

      .sub-menu-item {
        // padding: 8px 0 0 0;
      }

      &.third-column {
        .menu-item {
          // padding: 8px 0;
        }

        .level-2 {
          padding-bottom: 10px;
        }
      }


      // 根据层级设置不同的样式
      .menu-item.level-2 {
        font-weight: bold;
        font-weight: 700;
      }

      .menu-item.level-2>a:first-child {
        font-weight: 700;
        font-size: 16px;
        line-height: 1.2;
      }

      .sub-menu-item.level-3>a:first-child {
        font-weight: 700;
        padding-bottom: 10px;
      }

      .sub-menu-item.level-3 {
        // padding-left: 15px;
        font-size: 13px;
      }

      .sub-sub-menu-item.level-4 {
        // padding-left: 30px;
        font-size: 13px;
        line-height: 18px;
      }

      .children-container {
        // margin-top: 5px;
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        // gap: 8px;


        // a{
        //   font-size: 14px;
        // }
      }
    }

    .first-column,
    .second-column,
    .third-column {
      flex: 0 0 16.6%;
      max-width: 16.6%;
    }

    .fourth-column {
      flex: 0 0 50%;
      max-width: 50%;
      padding: 0 0 0 16px;
      gap: 24px;

      .lp-page-null-section,
      .lp-page-name-section {
        // margin-bottom: 24px;
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        gap: 10px;

        .level-2 {
          font-weight: 700;
          font-size: 16px;
        }

        &:last-child {
          margin-bottom: 0;
        }

        .lp-item {
          padding: 5px 0;
        }
      }

      .lp-page-null-section {
        width: 100%;

        .lp-page-null-list {
          display: flex;
          align-items: flex-start;
          flex-direction: row;
          gap: 10px;
          width: 100%;

          .swiper-x-container {
            // position: relative;


            .swiper-block-only-item {
              // flex: 1;
              // width: calc(25% - 10px);
              // max-width: calc(25% - 10px);
              box-sizing: border-box;
              padding: 5px 0;

              img {
                width: 100%;
                height: auto;
              }
            }

            .arrow {
              width: 40px;
              height: 40px;
              display: flex;
              align-items: center;
              justify-content: center;
              position: absolute;
              top: 48%;
              transform: translate(-50%, -50%);
              color: #212322;
              z-index: 99;
              border-radius: 50%;
              /* 修改为50%透明度 */
              box-sizing: border-box;
              border: 1px solid #212322;
              background: rgba(255, 255, 255, 0.5);
              transition: all .35s ease-in-out;

              &:hover {
                background: #212322;

                .iconfont-ot-website {
                  color: #fff;
                }
              }

              &.arrow-left {
                left: 34px;
              }

              &.arrow-right {
                right: -6px;
              }

              .iconfont-ot-website {
                font-size: 20px;

                color: #212322;

                &.icon-left-arrow {
                  left: 25px;
                  transform: rotate(180deg);



                  &:hover {
                    color: #fff;
                  }
                }

                &.icon-right-arrow {
                  right: 25px;

                  &:hover {
                    color: #fff;
                  }
                }
              }
            }
          }
        }

        .lp-item {
          flex: 1;
          // width: calc(25% - 8px);
          max-width: calc(25%);
          box-sizing: border-box;

          &.lp-null-count-2,
          &.lp-null-count-3 {
            max-width: calc(25% - 7.5px);

          }

          img {
            width: 100%;
            height: auto;
          }
        }
      }

      .lp-page-name-section {
        flex-wrap: wrap;

        .lp-page-name-list {
          display: flex;
          align-items: flex-start;
          flex-direction: row;
          flex-wrap: wrap;
          gap: 10px;
          // row-gap: 30px;
          // column-gap: 10px;
          width: 100%;

          .lp-item {
            // flex: 1;
            width: calc(20% - 8px);
            box-sizing: border-box;

            a,
            router-link {
              display: flex;
              flex-direction: column;
              align-items: center;
              text-align: center;
              // text-decoration: none;
            }

            img {
              width: 100%;
              aspect-ratio: 1 / 1;
              /* 明确指定1:1比例 */
              // object-fit: cover;
              display: block;
            }

            .name {
              color: var(---, #212322);
              font-family: Matter;
              font-size: 12px;
              font-style: normal;
              font-weight: 600;
              line-height: 16px;
              text-transform: capitalize;
            }
          }
        }
      }
    }
  }

  .multiline-1 {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    line-height: 1.2;
  }

  .multiline-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>